export { getSortedRoutes } from './sorted-routes'
export { isDynamicRoute } from './is-dynamic'
